// src/routes/PrivateRoute.jsx
import React from 'react'
import { Route, Redirect } from 'react-router-dom'
import { useAuth } from 'providers/auth-provider'

const PrivateRoute = ({ component: Component, ...rest }) => {
  const { isAuth, isLoading } = useAuth()
  return (
    <Route
      {...rest}
      render={(props) => {
        if (isLoading) return null
        return isAuth ? <Component {...props} /> : <Redirect to="/" />
      }}
    />
  )
}

export default PrivateRoute
